class CookieService {
  static set(key, value, expiryMinutes) {
    const expiryDate = new Date();

    expiryDate.setTime(
      expiryDate.getTime() + parseInt(expiryMinutes) * 60 * 1000
    ); // Convert minutes to milliseconds
    document.cookie = `${key}=${value}; path=/; expires=${expiryDate.toUTCString()}; Secure; SameSite=Strict`;
  }

  static get(key) {
    const cookies = document.cookie.split("; ");
    const cookie = cookies.find((row) => row.startsWith(`${key}=`));

    return cookie ? cookie.split("=")[1] : null;
  }

  static remove(key) {
    document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
  }

  static clear() {
    // document.cookie = `auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;

    document.cookie = `token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
    // document.cookie = `refresh_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
    // document.cookie = `joined_at=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
    // document.cookie = `session_end=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
    // document.cookie = `session_start=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
    // document.cookie = `webinar=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
    // document.cookie = `webinar_duration=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
    // document.cookie = `expire_after=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
    // document.cookie = `attendee=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict`;
  }
}

export default CookieService;
